export const trackingEvents = {
  aiFlowStarted: 'aiFlowStarted',
  aiFeedback: 'aiFeedback',
  aiFlowSelectQuestion: 'aiFlowSelectQuestion',
  aiFlowEnterQuestion: 'aiFlowEnterQuestion',
  aiFlowFollowupQuestion: 'aiFlowFollowupQuestion',
  aiFlowNewChat: 'aiFlowNewChat',
  aiExpanded: 'aiExpanded',
  aiFlowEnd: 'aiFlowEnd',

  // New Tracking August 2025
  AISumThumbsUp: 'AISumThumbsUp',
  AISumThumbsUpReasons: 'AISumThumbsUpReasons',
  AISumThumbsUpExplanation: 'AISumThumbsUpExplanation',

  AISumThumbsDown: 'AISumThumbsDown',
  AISumThumbsDownReasons: 'AISumThumbsDownReasons',
  AISumThumbsDownExplanation: 'AISumThumbsDownExplanation',

  AIConsentShown: 'AIConsentShown',
  AIConsentAccepted: 'AIConsentAccepted',
  AIConsentDismissed: 'AIConsentDismissed',
  AISumClick: 'AISumClick',

  AIChatClick: 'AIChatClick',
  AIChatSaved: 'AIChatSaved',
  AIChatNew: 'AIChatNew',
  AIChatClosed: 'AIChatClosed',

  AIChatThumbsUp: 'AIChatThumbsUp',
  AIChatThumbsUpExplanation: 'AIChatThumbsUpExplanation',
  AIChatThumbsDown: 'AIChatThumbsDown',
  AIChatThumbsDownExplanation: 'AIChatThumbsDownExplanation',
};
